import styled from "styled-components";
import { images } from "../../constants";

const Title = styled.div`
  text-align: center;
  .title {
    color: var(--white);
    font-size: 2rem;
  }
  .subtitle {
    color: var(--white);
    font-size: 1.8rem;
  }
`;
const TitleLogo = ({ title, to }) => {
  return (
    <Title>
      <h1 className="title title-700-28-text-gray">{title}</h1>
      <h2 className="subtitle">{to}</h2>
      <img src={images.logoHWthite} alt="logo origo horizontal white" />
    </Title>
  );
};

export default TitleLogo;
